import React, { useState, useEffect, useContext } from 'react';

// components
import CartItemMembershipDonation from './CartItemMembershipDonation';
import CartItemMembershipPac from './CartItemMembershipPac';
import { LabelSmall } from '@styled';

// functionality
import { CartItemMembershipContext } from './CartItemMembershipProvider';
import useMemberDuesEligibilityFromAPI from '@hooks/apiLegacy/useMemberDuesEligibilityFromAPI';

const CartItemMembershipDonations = () => {
    // -----------------------------
    // State
    // -----------------------------

    const [pac, setPac] = useState();
    const [sic, setSic] = useState();
    const [fnd, setFnd] = useState();

    // -----------------------------
    // Hooks
    // -----------------------------

    const { membershipDataForMember } = useContext(CartItemMembershipContext);
    const { memberDuesEligibility } = useMemberDuesEligibilityFromAPI({ id: membershipDataForMember.memberId });

    // -----------------------------
    // Effects
    // -----------------------------

    useEffect(() => {
        if (!memberDuesEligibility) {
            return;
        }

        setPac(memberDuesEligibility.pac);
        setSic(memberDuesEligibility.sic);
        setFnd(memberDuesEligibility.fnd);
    }, [memberDuesEligibility]);

    // -----------------------------
    // Render
    // -----------------------------

    if (!pac && !sic && !fnd) {
        return null;
    }

    return (
        <div className="pt-1rem">
            <LabelSmall className="block">Add a donation:</LabelSmall>

            {pac && (
                <div className="mt-1rem">
                    <CartItemMembershipPac pacFees={pac} />
                </div>
            )}

            {sic && (
                <div className="mt-1rem">
                    <CartItemMembershipDonation feesForType={sic} type="sic" />
                </div>
            )}

            {fnd && (
                <div className="mt-1rem">
                    <CartItemMembershipDonation feesForType={fnd} type="fnd" />
                </div>
            )}
        </div>
    );
};

export default CartItemMembershipDonations;
